import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Apollo} from "apollo-angular";
import {get_project_prospect_deals} from "../graphql/getSyndications";

@Component({
    selector: 'app-add-syndications-pipeline',
    templateUrl: './add-syndications-pipeline.component.html',
    styleUrls: ['./add-syndications-pipeline.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddSyndicationsPipelineComponent implements OnInit{
  public prospectDeals:any[] = []
  constructor(private apollo: Apollo) {
  }
  ngOnInit() {
    this._getProspectProjects()

  }

  private _getProspectProjects(){
    this.apollo.watchQuery({
      query: get_project_prospect_deals
    }).valueChanges.subscribe((response:any) => {
      response.data.projects.forEach((proj:any) => {
        let obj = {
          id: proj.id,
          name: proj.name,
          isExpanded: false
        }
        this.prospectDeals.push(obj)
      })
    })
  }
}
